import { Helmet } from 'react-helmet-async';
import type { AnyRouter } from '@tanstack/react-router';

import { TenantAppShell } from '@/app/tenant-app-shell';
import { tryRefreshToken } from '@features/login';
import { useIsOnline } from '@shared/lib/hooks';

/**
 * Shared shell for the "reader family" (daily/starmagazine/toyota) --
 * improvements/07-template-architecture.md's reader-family collapse, Phase 1.
 * App.tsx/App.hooks.ts were byte-identical across all three, so this is a
 * pure dedup: each template keeps its own thin `App.tsx` (importing its own
 * `App.css`, which still differs per tenant -- not merged this pass) that
 * renders this component with its own `router`.
 */
export function ReaderApp({ router }: { router: AnyRouter }) {
	const isOnline = useIsOnline();

	return (
		<TenantAppShell
			router={router}
			refresh={{ tryRefreshToken, intervalMs: 30 * 1000, enabled: isOnline }}
			head={
				<Helmet>
					<meta
						name="theme-color"
						content={isOnline ? '#fff' : '#f00'}
					/>
				</Helmet>
			}
		/>
	);
}

export default ReaderApp;
